module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/10O0t6M/tc-custom/9781642501780.jpg?1728851752782",
      "alt": "This image is the cover for the book Navigating College With the 7 Habits"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Navigating College With the 7 Habits\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An education expert shares step-by-step advice for improving your college experience by developing academic and life skills.")]), _c('br'), _c('br'), _vm._v("As President of FranklinCovey Education, Sean Covey has long been dedicated to transforming education. In "), _c('i', [_vm._v("Navigating College With the 7 Habits")]), _vm._v(", he shows college students how to establish habits that lead to a more effective learning experience. This step-by-step book provides readers with the skills, tools, and mindset they need to resolve anything from roommate issues to struggles with difficult classes."), _c('br'), _c('br'), _vm._v("Studying and retention skills are incredibly beneficial to student life, but so are essential life skills such as communication and time management. By discovering the value in both academic and life skills, readers can better establish and accomplish a vision for their education and success."), _c('br'), _c('br'), _c('i', [_vm._v("Navigating College With the 7 Habits")]), _vm._v(" can help you:Get more engaged in class and studiesGain critical skills like money management, goal achievement, conflict resolution, and health and wellnessAdopt essential habits, such as Be Proactive, Think Win-Win, and more\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sean Covey\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Mango Publishing Group\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0